const state = {
  invoiceItemTags: {
    sub: 'SUBSCRIPTION',
    sub_addon: 'SUBSCRIPTION ADD-ON'
  }
};

export default {
  namespaced: true,
  state
};
